import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import { SpinnerIndicator } from "components/CallServer";
import QuillTextExpander from "components/Quill/QuillTextExpander";
import * as React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {

    /** Texto que deve ser exibido */
    text: string;

    /** Informa se o texto está expandido. São três valores possíveis: (true) está expandido, (false) está retraído ou (null) está expandido mas não pode ser contraído. */
    expanded?: boolean;

    /** Texto para informar contração do conteúdo */
    lessText?: string | React.ReactNode;

    /** Texto para informar expansão do conteúdo */
    moreText?: string | React.ReactNode;

    /** Evento quando o botão de expansão/contração é pressionado. */
    onTextExpandedChange?: (expanded: boolean) => void;

    /** Evento ocorre quando uma imagem do text for clicada. */
    onImageClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
}

type Props = IProps & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////

const BodyTextExpand: React.FC<Props> = (props) => {

    const { t } = useTranslation();
    const { classes, text, expanded, moreText, lessText, onImageClick, onTextExpandedChange } = props;

    if (text == null && expanded !== null) {
        // Texto pode ser expandido ou contraído mas ainda não foi carregado.
        return <SpinnerIndicator />;
    }

    // Exibe o texto carregado.
    return (
        <QuillTextExpander
            text={text}
            buttonClassName={classes.expandButton}
            imageClassName={classes.imageZoomIn}
            moreText={moreText || t("Common.Feed.Literals.ShowMoreText")}
            lessText={lessText || t("Common.Feed.Literals.ShowLessText")}
            expanded={expanded}
            onTextExpandedChange={onTextExpandedChange}
            onImageClick={onImageClick}
        />
    );
};

BodyTextExpand.defaultProps = {
    expanded: null        // Valor null: significa que o texto não deve ser expandido ou contraído.
};

export default BodyTextExpand;